/** @format */

import { Suspense } from "react";

import { ComponentError } from "errors";

export default function MenuComponent(props) {
  const { menus, position, desk } = props;
  if (menus[position] && menus[position][desk]) {
    let Component = menus[position][desk];
    if (!Component) return <></>;
    return (
      <ComponentError>
        <Suspense>
          <Component {...props} />
        </Suspense>
      </ComponentError>
    );
  } else {
    return <></>;
  }
}
